angular.module('chat2')
    .directive("fileModel", function () {
        return {
            restrict: 'EA',
            scope: {
                setFileData: "&"
            },
            link: function (scope, ele, attrs) {
                ele.on('change', function () {
                    scope.$apply(function () {
                        var val = ele[0].files[0];
                        scope.setFileData({ value: val });
                    });
                });
            }
        }
    })
    .directive("onAttachmentLoad", [function () {

        function parseFilename(filename) {

            var result = {
                name: filename,
                extension: ""
            }


            var splitResult = filename.split('.');

            if (splitResult.length >= 2) {

                result.extension = splitResult.pop();
                result.name = splitResult.join(".");
            } else {
                result.name = filename;
            }

            return result;
        }

        return {
            scope: {
                onAttachmentLoad: "&"
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        var splitResult = changeEvent.target.files[0].type.split("/");

                        var parsed = parseFilename(changeEvent.target.files[0].name);

                        var data = {
                            dataUrl: loadEvent.target.result,
                            file: changeEvent.target.files[0],
                            type: splitResult[0],
                            subtype: splitResult[1],
                            extension: parsed.extension,
                            name: parsed.name
                        };
                        scope.onAttachmentLoad({ data: data });
                        element.val(null);  // clear input

                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]); 